export const LOCAL_STORAGE = {
  executed_auth_action: "executed_auth_action",
  activated_account_email: "activated_account_email"
};

export const AUTH_ACTIONS = {
  account_activation: "account_activation",
  password_reset: "password_reset"
};
